<template>
 <div id="app">
  <RouterView name="default" :dataset="dataset"></RouterView>
 </div>
</template>

<script>

import Vue from "vue"
import JsonExcel from "vue-json-excel"
import i18n from '@/mixins/i18n'
import api from '@/api/api'
 
Vue.component("downloadExcel", JsonExcel)

export default {
  name: 'AppEndPoint',
  mixins: [i18n, api],
  props: {
    locale: {
      type: String,
      default: null
    }
  },  
  beforeMount () {
    this.setLocale(this.$route.params.locale)
    window.scrollTo(0, 0)
  },
  beforeRouteUpdate (to, from, next) {
    this.setLocale(to.params.locale)
    next()
  }
}
</script>

<style lang="scss">
  @import 'node_modules/bootstrap/scss/bootstrap.scss';
  @import 'node_modules/bootstrap-vue/src/index.scss';
  @import './assets/style/main.scss';
</style>
